(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
  if (customElements.get('sticky-header')) return;

  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.lifecycleActive = false;
      this.connectionToken = 0;
      this.geometryRaf = null;
      this.stateRaf = null;
      this.transitionRaf = null;
      this.revealTimer = null;
      this.resizeObserver = null;
      this.pendingState = null;

      this.onScroll = this.onScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.updateGeometry = this.updateGeometry.bind(this);
      this.handlePageShow = this.handlePageShow.bind(this);
      this.handleTransitionRun = this.handleTransitionRun.bind(this);
      this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
      this.hideHeaderOnScrollUp = this.hideHeaderOnScrollUp.bind(this);
    }

    connectedCallback() {
      if (this.lifecycleActive) return;

      this.header = this.closest('.section-header');
      if (!this.header) return;

      this.lifecycleActive = true;
      const token = ++this.connectionToken;
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.stickyType = this.dataset.stickyType || 'none';
      this.headerIsAlwaysSticky = this.stickyType === 'always';
      this.currentScrollTop = window.scrollY;
      this.headerNaturalTop = this.header.getBoundingClientRect().top + window.scrollY;
      this.preventReveal = false;
      this.scrollThreshold = 5;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      document.addEventListener('semu:header:measure', this.updateGeometry);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      window.addEventListener('pageshow', this.handlePageShow);
      this.header.addEventListener('transitionrun', this.handleTransitionRun);
      this.header.addEventListener('transitionend', this.handleTransitionEnd);
      this.header.addEventListener('transitioncancel', this.handleTransitionEnd);

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this);
        if (this.announcementBar) this.resizeObserver.observe(this.announcementBar);
      }

      this.resetStickyState();
      this.updateGeometry();

      if (this.stickyType === 'on-scroll-up' && window.scrollY > this.headerThreshold) {
        this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
        this.updateGeometry();
      }

      document.fonts?.ready.then(() => {
        if (!this.lifecycleActive || token !== this.connectionToken || !this.isConnected) return;
        this.scheduleGeometry();
      });
    }

    resetStickyState() {
      this.header.classList.remove(
        'scrolled-past-header',
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
    }

    disconnectedCallback() {
      if (!this.lifecycleActive) return;

      this.lifecycleActive = false;
      this.connectionToken += 1;
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      document.removeEventListener('semu:header:measure', this.updateGeometry);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('pageshow', this.handlePageShow);
      this.header?.removeEventListener('transitionrun', this.handleTransitionRun);
      this.header?.removeEventListener('transitionend', this.handleTransitionEnd);
      this.header?.removeEventListener('transitioncancel', this.handleTransitionEnd);

      this.resizeObserver?.disconnect();
      this.resizeObserver = null;

      if (this.geometryRaf !== null) cancelAnimationFrame(this.geometryRaf);
      if (this.stateRaf !== null) cancelAnimationFrame(this.stateRaf);
      if (this.transitionRaf !== null) cancelAnimationFrame(this.transitionRaf);
      window.clearTimeout(this.revealTimer);

      this.geometryRaf = null;
      this.stateRaf = null;
      this.transitionRaf = null;
      this.revealTimer = null;
      this.pendingState = null;
      this.resetStickyState();
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.scheduleGeometry();

      if (this.stickyType !== 'on-scroll-up') {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (Math.abs(scrollTop - this.currentScrollTop) < this.scrollThreshold) {
        return;
      }

      const scrollingDown = scrollTop > this.currentScrollTop;
      const pastHeaderThreshold = scrollTop > this.headerThreshold;

      if (pastHeaderThreshold) {
        this.header.classList.add('scrolled-past-header');

        if (scrollingDown) {
          this.queueState('hide');
        } else {
          if (!this.preventReveal) {
            this.queueState('reveal');
          } else {
            window.clearTimeout(this.revealTimer);
            this.revealTimer = window.setTimeout(() => {
              this.preventReveal = false;
            }, 66);
          }
        }
      } else {
        this.header.classList.remove('scrolled-past-header');
        this.queueState('reset');
      }

      this.currentScrollTop = scrollTop;
    }

    queueState(state) {
      this.pendingState = state;
      if (this.stateRaf !== null) return;

      this.stateRaf = requestAnimationFrame(() => {
        this.stateRaf = null;
        const nextState = this.pendingState;
        this.pendingState = null;
        this[nextState]?.();
        this.scheduleGeometry();
      });
    }

    hide() {
      if (this.stickyType !== 'on-scroll-up') return;
      this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.stickyType !== 'on-scroll-up') return;
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.stickyType !== 'on-scroll-up') return;
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.remove('shopify-section-header-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close?.());
    }

    hideHeaderOnScrollUp() {
      this.preventReveal = true;
    }

    handleResize() {
      this.scheduleGeometry();
    }

    handlePageShow() {
      this.currentScrollTop = window.scrollY;
      this.scheduleGeometry();
    }

    scheduleGeometry() {
      if (!this.lifecycleActive || this.geometryRaf !== null) return;

      this.geometryRaf = requestAnimationFrame(() => {
        this.geometryRaf = null;
        this.updateGeometry();
      });
    }

    getVisibleBottom(element) {
      if (!element) return 0;

      const rect = element.getBoundingClientRect();
      if (rect.height <= 0 || rect.bottom <= 0 || rect.top >= window.innerHeight) return 0;

      return Math.min(window.innerHeight, Math.max(0, rect.bottom));
    }

    setGeometryProperty(name, value) {
      const rounded = Math.round(Math.max(0, value) * 1000) / 1000;
      const nextValue = `${rounded}px`;
      const rootStyle = document.documentElement.style;

      if (rootStyle.getPropertyValue(name) !== nextValue) {
        rootStyle.setProperty(name, nextValue);
      }
    }

    updateGeometry() {
      if (!this.lifecycleActive || !this.header || !this.isConnected) return;

      const headerHeight = this.getBoundingClientRect().height;
      const announcementHeight = this.announcementBar?.getBoundingClientRect().height || 0;
      const headerRect = this.header.getBoundingClientRect();
      const visibleBottom = Math.max(
        this.getVisibleBottom(this.announcementBar),
        this.getVisibleBottom(this.header)
      );

      this.headerHeight = headerHeight;
      if (!this.header.classList.contains('shopify-section-header-sticky')) {
        this.headerNaturalTop = headerRect.top + window.scrollY;
      }
      this.headerThreshold = this.headerNaturalTop + headerHeight;
      this.setGeometryProperty('--header-height', headerHeight);
      this.setGeometryProperty('--announcement-height', announcementHeight);
      this.setGeometryProperty('--header-visible-bottom', visibleBottom);
    }

    handleTransitionRun(event) {
      if (event.target !== this.header || event.propertyName !== 'transform' || this.transitionRaf !== null) return;

      const startedAt = performance.now();
      const measureTransition = (timestamp) => {
        this.updateGeometry();

        if (this.lifecycleActive && timestamp - startedAt < 500) {
          this.transitionRaf = requestAnimationFrame(measureTransition);
        } else {
          this.transitionRaf = null;
        }
      };

      this.transitionRaf = requestAnimationFrame(measureTransition);
    }

    handleTransitionEnd(event) {
      if (event.target !== this.header || event.propertyName !== 'transform') return;

      if (this.transitionRaf !== null) cancelAnimationFrame(this.transitionRaf);
      this.transitionRaf = null;
      this.updateGeometry();
    }
  }

  customElements.define('sticky-header', StickyHeader);
  })();

  } catch(e) { console.error(e); }
})();
})();
